export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="z-[5] mx-auto flex w-full max-w-screen-sm items-center justify-center px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] xl:mb-2 xl:w-[1310px] xl:pb-6">
      <p className="text-center text-sm font-medium text-gray-600 md:text-base lg:text-white">
        © {year} Easyfollow Platform. All rights reserved.
      </p>
    </div>
  );
}
